import script from "./UiKitBrands.vue?vue&type=script&setup=true&lang=ts"
export * from "./UiKitBrands.vue?vue&type=script&setup=true&lang=ts"

import "./UiKitBrands.vue?vue&type=style&index=0&id=0449ad5c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0449ad5c"]])

export default __exports__